/** Progressive material study. Commerce remains owned by Horizon. */
class BruttusProductStudy extends HTMLElement {
  connectedCallback() {
    this.dispose?.();
    const controller = new AbortController();
    const desktop = matchMedia('(min-width: 990px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const chapters = [...this.querySelectorAll('[data-study-chapter]')];
    const images = [...this.querySelectorAll('[data-study-image]')];
    let observer, request = 0;
    const setActive = async (index) => {
      const ticket = ++request;
      const next = images[index]?.querySelector('img');
      if (!next) return;
      if (!next.complete || !next.naturalWidth) {
        next.loading = 'eager';
        try { await next.decode(); } catch { return; }
      }
      if (ticket !== request || controller.signal.aborted || !this.isConnected) return;
      images.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === index));
    };
    const configure = () => {
      ++request;
      observer?.disconnect();
      const motionEnabled = document.documentElement.dataset.btMotion !== 'off' && !window.Shopify?.designMode;
      this.classList.toggle('has-study-motion', desktop.matches && !reduced.matches && motionEnabled);
      if (!desktop.matches || reduced.matches || !motionEnabled || !('IntersectionObserver' in window)) {
        return;
      }
      observer = new IntersectionObserver((entries) => {
        const entry = entries.filter((item) => item.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (entry) setActive(Number(entry.target.dataset.studyChapter));
      }, { rootMargin: '-25% 0px -35% 0px', threshold: [0, .25, .5] });
      chapters.forEach((chapter) => observer.observe(chapter));
    };
    desktop.addEventListener('change', configure, { signal: controller.signal });
    reduced.addEventListener('change', configure, { signal: controller.signal });
    this.addEventListener('shopify:block:select', (event) => {
      const chapter = event.target.closest('[data-study-chapter]');
      if (chapter) setActive(Number(chapter.dataset.studyChapter));
    }, { signal: controller.signal });
    configure();
    this.dispose = () => { observer?.disconnect(); controller.abort(); };
  }
  disconnectedCallback() { this.dispose?.(); }
}
if (!customElements.get('v14-product-study')) customElements.define('v14-product-study', BruttusProductStudy);
